import { Component, Input, OnInit } from '@angular/core';
import { ConfigurationService, PathsService } from '@draeger-academy/common';
import { BehaviorSubject, Observable } from 'rxjs';
import { SearchReasult } from 'models/searchResult';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { TranslateService } from '@ngx-translate/core';
// import { TranslateService } from '@ngx-translate/core/lib/translate.service';
import { CartItem } from 'models/cartItem';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

@Component({
    selector: 'da-search-item',
    templateUrl: './search-item.component.html',
    styleUrls: ['./search-item.component.scss'],
    standalone: false
})
export class SearchItemComponent implements OnInit {
    @Input() course: SearchReasult;
    @Input() allCategories: any;
    public dynamicParameter: string;
    public language: string;
    public courseDetail: string;
    public booking: string;
    public courseImage: string;
    public alt = '';
    public currency = '';
    public show = false;
    public showWarning: boolean = false;
    public isNew: boolean = false;
    public isBestSeller: boolean = false;
    public isWebinar: boolean = false;
    public courseTitle: string = '';
    public lastWord: string = '';

    private _$courseImage: BehaviorSubject<{}> = new BehaviorSubject<{}>(null);
    private _$course: BehaviorSubject<SearchReasult> = new BehaviorSubject<SearchReasult>(null);
    private _$events: BehaviorSubject<CartItem[]> = new BehaviorSubject<CartItem[]>([]);
    private _$hasEventsInitially: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private _$translations: BehaviorSubject<any> = new BehaviorSubject({});

    constructor(
        // private _translateService: TranslateService,
        public _configurationService: ConfigurationService,
        private _translateService: TranslateService,
        private _pathsService: PathsService,
        private _localizeRouterService: LocalizeRouterService,
        private router: Router
    ) {
        // _translateService.get('language').subscribe((res: string) => {
        //     this.language = res;
        // });
    }

    public get courseImage$(): Observable<{}> {
        return this._$courseImage.asObservable();
    }

    public get course$(): Observable<SearchReasult> {
        return this._$course.asObservable();
    }

    public get events$(): Observable<CartItem[]> {
        return this._$events.asObservable();
    }

    public get hasEventsInitially$(): Observable<boolean> {
        return this._$hasEventsInitially.asObservable();
    }

    private _$showCartUpdate: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public get showCartUpdate$(): Observable<boolean> {
        return this._$showCartUpdate.asObservable();
    }

    private _$courseCategory: BehaviorSubject<string> = new BehaviorSubject('');
    public get courseCategory$(): Observable<string> {
        return this._$courseCategory.asObservable();
    }

    private _$showCartUpdatePrebooking: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public get showCartUpdatePrebooking$(): Observable<boolean> {
        return this._$showCartUpdatePrebooking.asObservable();
    }

    private _$showVat: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public get showVat$(): Observable<boolean> {
        return this._$showVat.asObservable();
    }

    private _$showLabels: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public get showLabels$(): Observable<boolean> {
        return this._$showLabels.asObservable();
    }

    private _$showShortDesc: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public get showShortDesc$(): Observable<boolean> {
        return this._$showShortDesc.asObservable();
    }

    ngOnInit() {
        if (this.course) {
            this.courseDetail = this._pathsService.getCourseDetailLink(this.course.id);
            this.booking = this._pathsService.getBookingLink(this.course.id);
            this._$course.next(this.course);
            if (this.course.image) {
                if (this.course.image.uri) {
                    this.courseImage = environment.APIEndpoint + this.course.image.uri;
                    this._$courseImage.next(this.courseImage);
                }
                if (this.course.image && this.course.image.fileName) this.alt = this.course.image.fileName;
            }
        }
    }

    public goToPage() {
        if (this.course.isEvent) {
            let translatedPath: any = this._localizeRouterService.translateRoute('/' + 'event' + '/' + this.course.link);
            this.router.navigate([translatedPath]);
        } else {
            let translatedPath: any = this._localizeRouterService.translateRoute('/' + 'course' + '/' + this.course.link);
            this.router.navigate([translatedPath]);
        }
    }
}
